export const addAllToSet = (set, ...values) => {
  values.forEach(value => set.add(value));
  return set;
}